/* eslint-disable @typescript-eslint/no-namespace */
import { type Brand, make } from "ts-brand";
import { type Identity, type OrderPermission } from "./Permission";

export type WorkloadToken<P, T> = {
    payload: P;
    token: T;
};

export namespace Token {
    export type IdentityToken = Brand<string, Identity>;
    export type OrderPermissionToken = Brand<string, OrderPermission>;

    export const IdentityToken = make<IdentityToken>(value => {
        if (!value || value.trim() === "") {
            throw new Error("IdentityToken: Property 'value' cannot be empty.");
        }
    });

    export const OrderPermissionToken = make<OrderPermissionToken>(value => {
        if (!value || value.trim() === "") {
            throw new Error("OrderPermissionToken: Property 'value' cannot be empty.");
        }
    });
}
